import React, { useId } from 'react'

/** textPath 원호 반경 (viewBox 기준); 원주 길이와 반드시 맞출 것 */
const RING_TEXT_RADIUS = 106

/**
 * 홈 링 배지 회전 레이어 (인라인 SVG textPath).
 * StrictMode 이중 마운트 시 고정 id 충돌 시 문자가 전혀 안 나올 수 있어 useId() 로 path id 분리.
 * 마스크·도넛 clip 은 엔진마다 텍스트가 통째로 사라지는 사례가 있어 사용하지 않음.
 */
export default function CodamHomeRingGraphic({ className }) {
    const uid = useId().replace(/:/g, '_')
    const pathId = `codam-ring-textpath-${uid}`
    const svgClasses = ['codam-home-ring-svg', className].filter(Boolean).join(' ')
    /** 한 바퀴 길이—textLength 에 맞추면 잘림 없이 간격만 늘리거나 줄여 채움 */
    const pathCircumference = 2 * Math.PI * RING_TEXT_RADIUS * 0.992

    return (
        <svg
            className={svgClasses}
            width="220"
            height="220"
            viewBox="0 0 220 220"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            role="img"
            aria-hidden="true"
            focusable="false"
        >
            <defs>
                <path
                    id={pathId}
                    fill="none"
                    stroke="none"
                    d={`M110,110 m-${RING_TEXT_RADIUS},0 a${RING_TEXT_RADIUS},${RING_TEXT_RADIUS} 0 1,1 ${2 * RING_TEXT_RADIUS},0 a${RING_TEXT_RADIUS},${RING_TEXT_RADIUS} 0 1,1 ${-2 * RING_TEXT_RADIUS},0`}
                />
            </defs>
            <text
                fill="#ffffff"
                stroke="none"
                strokeWidth="0"
                fontSize="26"
                fontWeight="700"
                fontFamily="system-ui, 'Segoe UI', Arial, Helvetica, sans-serif"
                lengthAdjust="spacing"
                textLength={pathCircumference}
                style={{ pointerEvents: 'none' }}
            >
                <textPath href={`#${pathId}`} xlinkHref={`#${pathId}`} startOffset="0%">
                    CODAM Enterprise IT Solutions Partner{'\u00a0\u00b7\u00a0'}
                </textPath>
            </text>
        </svg>
    )
}
